<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page @page:beforein="autoSave" style="width: 100%; overflow: hidden;">
    <f7-navbar :title="`${currentDraft.items[itemId].title}`" back-link="back">
      <f7-nav-right>
        <f7-link popover-open=".popover-menu">
          <font-awesome-icon icon="edit" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div style="display: flex; flex-direction: column; height: 100%; width: 100%; justify-content: center; overflow: hidden;">
      <template v-if="!hasFileLoaded">
        <img
          v-if="currentItem.coverImgUrl"
          :src="ImageUrlBuilder.url512(currentItem.coverImgUrl, storeIdProp)"
          style="position: absolute; top: 64px; width: 100%; margin: 0px;" />
        <img v-else slot="media" src="@/assets/itemDefault.jpg" alt="預設圖片" style="width: 100%;" />
      </template>

      <div ref="previewImgWrapperRef" style="flex: 1; overflow: hidden;">
        <div
          :style="{ width: frameSize + 'px', height: frameSize + 'px', 'border-radius': circleFilter ? '50%' : '0%' }"
          style="position: absolute; overflow: hidden; z-index: 10;">
          <img
            v-show="hasFileLoaded"
            ref="previewImgRef"
            :style="{ width: baseImageWidth + 'px', transform: `scale(${scale})` }"
            style="transform-origin: top left; position: absolute;"
            @load="onImageLoad"
            @touchstart="touchstart"
            @touchmove="touchmove" />
        </div>
        <div style="position: absolute; overflow: hidden; top: 56px; bottom: 0px; left: 0px; right: 0px;">
          <img
            v-show="hasFileLoaded"
            ref="previewImgBackgroundRef"
            :style="{ width: baseImageWidth + 'px', transform: `scale(${scale})` }"
            style="transform-origin: top left; position: absolute; opacity: 0.5;" />
        </div>
      </div>

      <f7-list v-if="hasFileLoaded" simple-list style="margin: 0px;">
        <f7-list-item>
          <f7-list-item-cell class="width-auto flex-shrink-0">
            <font-awesome-icon icon="minus" @click="decreaseScale" />
          </f7-list-item-cell>
          <f7-list-item-cell class="flex-shrink-3">
            <f7-range ref="scaleRangeRef" :max="maxScale" :step="0.1" :value="scale" @range:change="onScaleChange" />
          </f7-list-item-cell>
          <f7-list-item-cell class="width-auto flex-shrink-0">
            <font-awesome-icon icon="plus" @click="increaseScale" />
          </f7-list-item-cell>
        </f7-list-item>
      </f7-list>

      <f7-popover class="popover-menu">
        <f7-list>
          <!-- <f7-list-item link="#" popover-close title="選擇已上傳照片 (施工中)"></f7-list-item> -->
          <f7-list-item link="#" popover-close title="切換裁切形狀" @click="circleFilter = !circleFilter"></f7-list-item>
          <f7-list-item link="#" popover-close title="上傳" @click="upload"></f7-list-item>
          <f7-list-item link="#" popover-close title="選擇本機照片" @click="clickImgFileInput"></f7-list-item>
          <f7-list-item link="#" popover-close title="刪除" @click="deleteImage"></f7-list-item>
        </f7-list>
      </f7-popover>
      <input ref="imgFileRef" type="file" @change="previewFile" style="position: absolute; left: 0px; top: 0px; opacity: 0;">
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ElementPath from '@/components/ElementPath'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: ['ImageUrlBuilder'],
  data () {
    return {
      hasFileLoaded: false,
      previewImgWrapperWidth: 0,
      previewImgWrapperHeight: 0,
      baseImageWidth: 0,
      baseImageHeight: 0,
      frameSize: 0,
      baseScale: 1,
      maxScale: 10,
      scale: 1,
      previewImgPadding: 30,
      clientX: 0,
      clientY: 0,
      circleFilter: true
    }
  },
  mounted () {
    window.onresize = this.onWindowResize
    window.addEventListener('resize', this.onWindowResize)
    // Init
    this.getPreviewImgWrapperWidth()
    this.getPreviewImgWrapperHeight()
    this.frameSize = Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight)
  },
  beforeDestroy () {
    this.$f7.dialog.close()
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    currentItem () { return this.currentDraft.items[this.itemId] },
    itemId () { return this.currentElementPath[2].id }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'setItemProperties', 'saveDraft']),
    touchstart (e) {
      e.preventDefault()
      this.clientX = e.touches[0].clientX
      this.clientY = e.touches[0].clientY
    },
    touchmove (e) {
      let previewImgTopTarget = this.$refs.previewImgRef.offsetTop - this.clientY + e.touches[0].clientY
      let previewImgLeftTarget = this.$refs.previewImgRef.offsetLeft - this.clientX + e.touches[0].clientX
      const bottomBoundary = this.frameSize - this.baseImageHeight * this.scale
      const rightBoundary = this.frameSize - this.baseImageWidth * this.scale

      if (previewImgTopTarget > 0) { // 圖片最上面是否低於框框
        previewImgTopTarget = 0
      } else if (previewImgTopTarget < bottomBoundary) { // 圖片最下面
        previewImgTopTarget = bottomBoundary
      }

      if (previewImgLeftTarget > 0) {
        previewImgLeftTarget = 0
      } else if (previewImgLeftTarget < rightBoundary) {
        previewImgLeftTarget = rightBoundary
      }

      this.$refs.previewImgRef.style.top = previewImgTopTarget + 'px'
      this.$refs.previewImgBackgroundRef.style.top = previewImgTopTarget + 'px'
      this.clientY = e.touches[0].clientY

      this.$refs.previewImgRef.style.left = previewImgLeftTarget + 'px'
      this.$refs.previewImgBackgroundRef.style.left = previewImgLeftTarget + 'px'
      this.clientX = e.touches[0].clientX
    },
    onScaleChange (scale) {
      this.scale = scale
      this.$refs.previewImgRef.style.top = 0
      this.$refs.previewImgRef.style.left = 0
      this.$refs.previewImgBackgroundRef.style.top = 0
      this.$refs.previewImgBackgroundRef.style.left = 0
    },
    decreaseScale () {
      const newFloatScale = parseFloat(this.scale) - 0.1
      this.scale = newFloatScale >= this.baseScale ? newFloatScale : this.scale
    },
    increaseScale () {
      const newFloatScale = parseFloat(this.scale) + 0.1
      this.scale = newFloatScale <= this.maxScale ? newFloatScale : this.scale
    },
    getPreviewImgWrapperWidth () {
      this.previewImgWrapperWidth = this.$refs.previewImgWrapperRef.clientWidth
    },
    getPreviewImgWrapperHeight () {
      this.previewImgWrapperHeight = this.$refs.previewImgWrapperRef.clientHeight
    },
    onWindowResize () {
      this.getPreviewImgWrapperWidth()
      this.getPreviewImgWrapperHeight()
      this.frameSize = Math.min(this.previewImgWrapperWidth, this.previewImgWrapperHeight)
    },
    onImageLoad () {
      this.baseImageHeight = this.$refs.previewImgRef.clientHeight
      this.baseScale = this.previewImgWrapperWidth / Math.min(this.baseImageHeight, this.baseImageWidth)
      this.scale = this.baseScale
      this.$refs.scaleRangeRef.f7Range.min = this.baseScale
      this.$utils.nextFrame(() => this.$f7.dialog.close())
    },
    onFileLoad (e) {
      this.$refs.previewImgRef.src = e.target.result
      this.$refs.previewImgBackgroundRef.src = e.target.result
      this.baseImageWidth = this.previewImgWrapperWidth
      this.$refs.previewImgRef.style.top = 0
      this.$refs.previewImgRef.style.left = 0
      this.$refs.previewImgBackgroundRef.style.top = 0
      this.$refs.previewImgBackgroundRef.style.left = 0
      this.hasFileLoaded = true
    },
    async previewFile () {
      const reader = new FileReader()
      reader.onloadend = this.onFileLoad

      if (this.$refs.imgFileRef.files[0]) {
        this.$f7.dialog.progress('正在載入圖片，請稍待...')
        reader.readAsDataURL(this.$refs.imgFileRef.files[0]) // reads the data as a URL
      } else {
        this.$refs.previewImgRef.src = ''
      }
    },
    async upload () {
      try {
        const realScale = this.$refs.previewImgRef.naturalWidth / this.baseImageWidth / this.scale
        const formData = new FormData()
        formData.append('image', this.$refs.imgFileRef.files[0])
        formData.append('top', -this.$refs.previewImgRef.offsetTop * realScale)
        formData.append('left', -this.$refs.previewImgRef.offsetLeft * realScale)
        formData.append('frameSize', parseInt(this.frameSize * realScale))
        formData.append('naturalWidth', this.$refs.previewImgRef.naturalWidth)
        formData.append('naturalHeight', this.$refs.previewImgRef.naturalHeight)
        formData.append('filter', this.circleFilter ? 'circle' : 'square')
        this.$f7.dialog.progress('圖片上傳至伺服器壓縮裁切中，請稍待...')
        const coverImgUrl = this.currentDraft.items[this.itemId].coverImgUrl
        if (coverImgUrl) {
          storeClient.delete(`stores/${this.storeIdProp}/images?path=${coverImgUrl}`)
        }
        const result = await storeClient.post(
          `stores/${this.storeIdProp}/images/cover`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )

        this.setItemProperties({ itemId: this.itemId, properties: { coverImgUrl: this.storeIdProp + '/draft/' + result.data.imageId } })

        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.$f7router.back()
      } catch (e) {
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.$f7.dialog.alert('上傳失敗')
      }
    },
    clickImgFileInput () {
      this.$refs.imgFileRef.click()
    },
    autoSave () {
      if (this.currentDraft) {
        this.saveDraft(this.currentDraft.variation)
      }
    },
    deleteImage () {
      const coverImgUrl = this.currentDraft.items[this.itemId].coverImgUrl
      if (coverImgUrl) {
        storeClient.delete(`stores/${this.storeIdProp}/images?path=${coverImgUrl}`)
        this.setItemProperties({ itemId: this.itemId, properties: { coverImgUrl: '' } })
      }
      this.autoSave()
    }
  },
  components: {
    ElementPath
  }
}
</script>

<style lang="scss" scoped>
</style>
